import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import useStandProductService from "../../api/services/useStandProductService";
import useStandService from "../../api/services/useStandService";
import {getMediaThumbSrc} from "../../helpers/mediaUrl";
import Loading from "../../components/Loading/Loading";
import Button from "../../components/Button/Button";
import FeedbackPopup from "../../components/FeedbackPopup/FeedbackPopup";
import swal from "sweetalert";


const UserStandProducts = () => {

  const {standId} = useParams()
  const {userShow: standShow} = useStandService()
  const {userShowCollection, userDelete} = useStandProductService(standId)

  const [stand, setStand] = useState(null)
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    standShow((data) => setStand(data), () => {}, standId)
    userShowCollection(
      (data) => {
        setProducts(data || [])
        setIsLoading(false)
      },
      () => setIsLoading(false),
    )
  }, [standId])

  const formatPrice = (price) => {
    if (price === null || price === undefined) return null
    return '\u20AC ' + parseFloat(price).toFixed(2).replace('.', ',')
  }

  const handleDelete = (product) => {
    swal({
      title: 'Verwijderen?',
      text: 'Weet je zeker dat je dit product wilt verwijderen?',
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {text: 'Annuleren', value: null, visible: true, className: 'btn-color-grey btn-size-m', closeModal: true},
        confirm: {text: 'Verwijderen', value: true, visible: true, className: 'btn-color-red btn-size-m', closeModal: true}
      }
    }).then((result) => {
      if (result) {
        userDelete(
          () => {
            setProducts(prev => prev.filter(p => p.id !== product.id))
            swal({title: 'Verwijderd', icon: 'success', timer: 1000, buttons: false})
          },
          () => {},
          product.id,
        )
      }
    })
  }

  return (
    <div className="page-user-stand-products">
      <div className="row">
        <div className="col">
          <h1>Aanbod{stand ? ': ' + stand.label : ''}</h1>
          <p>Laat zien wat je verkoopt! Producten en prijzen die je hier toevoegt verschijnen op je profiel. Dit helpt locatie-eigenaren om te zien wat je aanbiedt.</p>
        </div>
        <div className="col col-feedback">
          <FeedbackPopup location={'/user/stand/' + standId + '/aanbod'}/>
        </div>
      </div>

      <div className="row buttons">
        <Button label={'Alle stands'} link={'/user/stands'}/>
        <Button
            label="+ Product toevoegen"
            link={'/user/stand/' + standId + '/aanbod/new'}
        />
        {stand && stand.slug &&
          <Button label="Bekijk profiel" link={'/stand/' + stand.slug}/>
        }
      </div>

      {isLoading ? <Loading/> :
        <div className="product-entries">
          {products.length === 0 &&
            <p className="empty-state">Nog geen producten toegevoegd. Voeg een product toe om je aanbod te tonen!</p>
          }
          {products.map((product) => {
            const thumbSrc = getMediaThumbSrc(product.media)
            const priceDisplay = formatPrice(product.price)

            return (
              <div key={product.id} className="product-entry">
                <div className="image">
                  {thumbSrc
                    ? <img src={thumbSrc} alt={product.label} loading="lazy"/>
                    : <div className="no-image">🛒</div>
                  }
                </div>
                <div className="col-mid">
                  <div className="entry-header">
                    <h4>{product.label}</h4>
                    {priceDisplay &&
                      <span className="price-badge">{priceDisplay}</span>
                    }
                  </div>
                  <div className="entry-meta">
                    {product.description && <p className="description">{product.description}</p>}
                  </div>
                </div>
                <div className="col-right">
                  <Button label="Bewerk" size="s" color="green" link={'/user/stand/' + standId + '/aanbod/' + product.id + '/edit'}/>
                  <Button label="Verwijder" size="xs" color="red" onClick={() => handleDelete(product)}/>
                </div>
              </div>
            )
          })}
        </div>
      }
    </div>
  )
}

export default UserStandProducts
